import React from 'react';
import { Facebook, Instagram, Mail, Phone, MapPin } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

const Footer = () => {
  const { t } = useLanguage();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-black border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid md:grid-cols-3 gap-12 mb-8">
          {/* Brand */}
          <div>
            <div className="flex items-center mb-4">
              <img 
                src="/milazzo-logo.svg" 
                alt="Milazzo Pizza" 
                className="h-12 w-auto"
              />
            </div>
            <p className="text-gray-400 text-sm leading-relaxed">
              {t('location')}
            </p>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-bold text-lg mb-4">{t('contact')}</h3>
            <div className="space-y-3">
              <a
                href="tel:+358504771588"
                className="flex items-center gap-3 text-gray-400 hover:text-red-500 transition-colors duration-300 text-sm"
              >
                <Phone className="w-4 h-4" />
                <span>050 477 1588</span>
              </a>
              <a
                href="mailto:info@milazzo.fi"
                className="flex items-center gap-3 text-gray-400 hover:text-red-500 transition-colors duration-300 text-sm"
              >
                <Mail className="w-4 h-4" />
                <span>info@milazzo.fi</span>
              </a>
              <a
                href="https://maps.google.com/?q=Maakotkantie+60+01450+Vantaa"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-start gap-3 text-gray-400 hover:text-red-500 transition-colors duration-300 text-sm"
              >
                <MapPin className="w-4 h-4 mt-1" />
                <span>Maakotkantie 60<br />01450 Vantaa</span>
              </a>
            </div>
          </div>

          {/* Social Media */}
          <div>
            <h3 className="text-white font-bold text-lg mb-4">{t('followUs')}</h3>
            <div className="flex items-center gap-4">
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-red-600 transition-all duration-300 transform hover:scale-110"
                aria-label="Facebook"
              >
                <Facebook className="w-5 h-5 text-white" />
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-red-600 transition-all duration-300 transform hover:scale-110"
                aria-label="Instagram"
              >
                <Instagram className="w-5 h-5 text-white" />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-500 text-sm">
              © {currentYear} Milazzo Pizza. {t('allRightsReserved')}
            </p>
            <a
              href="https://order.site/milazzo"
              target="_blank"
              rel="noopener noreferrer"
              className="text-red-500 hover:text-red-400 text-sm font-medium transition-colors duration-300"
            >
              {t('orderOnline')} →
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;